module.exports = __webpack_public_path__ + "img/ata.65afe1f1.svg";